import React, { useEffect } from "react";
import history from "../history";

import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Main from "./Main";
import Admin from "./Admin";
import RequireAuth from "./RequireAuth";
import Account from "./Account";
import { account } from "routes/config";
import { useNavigate } from "react-router-dom";
import { store } from "reactStore/MainStore";
import { useDispatch, useSelector } from "react-redux";

import { EMPTYSOTRE } from "reactStore/actions/Actions";
function Root() {
  const { IsCognito, currentName, currentPic, profile, rememberMe } =
    useSelector((state) => state.User);

  const dispatch = useDispatch();

  //   window.addEventListener('beforeunload', (event) => {

  //     if(rememberMe==false){

  //       let res=sessionStorage.getItem('mykey');
  // if(res==null){
  //   dispatch(EMPTYSOTRE())

  // }

  //     }

  //    ///// dispatch(EMPTYSOTRE())

  //     ///////localStorage.removeItem('xpereatoken');

  //     });

  return (
    <Router history={history}>
      <Routes>
        <Route path='/*' element={<Main />} />
        {/* <Route element={<RequireAuth />}>
          <Route path='admin/*' element={<Admin />} />
        </Route> */}

        <Route path={`${account}/*`} element={<Account />} />
      </Routes>
    </Router>
  );
}

export default Root;
